import { render } from "./SurgicalGuides.vue?vue&type=template&id=02bc3ff6"
import script from "./SurgicalGuides.vue?vue&type=script&lang=js"
export * from "./SurgicalGuides.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__